module.exports = __webpack_public_path__ + "static/blinkrx-e-prescribe-22d987e8a4d14a6c6e155aa278cb9720.png";